import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../api/client";
import useAuth from "../../hooks/useAuth";
import logo from "../../assets/logo.png";
import "./AuthPages.css";

// The "Allow" screen an MCP client sends you to when it connects by signing in.
// Reached through ProtectedRoute, so you log in first if you are not already.
export default function OAuthConsentPage() {
  const [params] = useSearchParams();
  const requestId = params.get("request");
  const { user } = useAuth();
  const [request, setRequest] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!requestId) {
      setError("This link is missing its sign-in request.");
      return;
    }
    api
      .get(`/oauth/requests/${requestId}`)
      .then((res) => setRequest(res.data.data))
      .catch((err) =>
        setError(err.response?.data?.error || "Could not load this sign-in request."),
      );
  }, [requestId]);

  const decide = async (approve) => {
    setBusy(true);
    try {
      const res = await api.post(`/oauth/requests/${requestId}`, { approve });
      window.location.assign(res.data.data.redirectUrl);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong. Try connecting again.");
      setBusy(false);
    }
  };

  const name = [user?.firstName, user?.lastName].filter(Boolean).join(" ");

  return (
    <div className="auth-shell">
      <section className="auth-main">
        <div className="auth-container">
          <div className="auth-header">
            <img src={logo} alt="DecisionFlow" className="auth-logo" />
            <h1>Connect AI assistant</h1>
          </div>

          {error ? <div className="auth-alert">{error}</div> : null}

          {request ? (
            <div className="auth-form">
              <p>
                <strong>{request.clientName}</strong> wants to read{" "}
                <strong>{request.tenantName}</strong> as <strong>{name}</strong>.
              </p>
              <p className="auth-message">
                It will see the projects, stages, tasks and workflows you can
                see. It cannot change anything.
                {request.scopes?.includes("email")
                  ? " It will also receive your email address, to identify your account."
                  : ""}{" "}
                After you allow it, you go back to{" "}
                <strong>{request.redirectHost}</strong>.
              </p>
              <p className="auth-message">
                Only allow this if you just started connecting an assistant
                yourself. You can disconnect it any time from AI Access in your
                profile menu.
              </p>
              <button
                type="button"
                className="auth-btn auth-btn-primary"
                disabled={busy}
                onClick={() => decide(true)}
              >
                Allow read access
              </button>
              <button
                type="button"
                className="auth-btn auth-btn-secondary"
                disabled={busy}
                onClick={() => decide(false)}
              >
                Deny
              </button>
            </div>
          ) : null}
        </div>
      </section>
    </div>
  );
}
